export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Příjemce:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uživatel nenalezen"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontakty"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podrobnosti"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Výběr uživatelů"])}
}